import { captureException } from '@sentry/browser';

export const captureError = (err: any) => {
  console.error(err);
  captureException(err);
};
